import InvitedUsers from './InvitedUsers';

export const InvitedUsersConfig = {
    settings: {
        layout: {
            config: {
                navbar: {
                    display: false
                },
                toolbar: {
                    display: false
                },
                footer: {
                    display: false
                }
            }
        }
    },
    routes: [
        {
            path: '/verify-new-user-token',
            component: InvitedUsers
        }
    ]

};


// WEBPACK FOOTER //
// ./src/main/content/invited-users/InvitedUsersConfig.js